import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFirebaseApp } from './config';
import { isNativeApp } from '../platform';
import { signInWithGoogleNative } from './nativeAuth';

// Opens the Google popup and returns a Firebase ID token. The token is sent to
// the Express backend, which verifies it with the Admin SDK before issuing our
// own JWT — the client-side result is never trusted on its own.
export async function signInWithGoogle(): Promise<string> {
  if (isNativeApp()) {
    return signInWithGoogleNative();
  }

  const app = getFirebaseApp();
  if (!app) throw new Error('Firebase is not configured.');
  const auth = getAuth(app);
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  return result.user.getIdToken();
}
